import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectAccessibilityData,
  setAccessibilityData,
} from 'reducers/accessibility';
import { selectWebskin } from 'reducers/auth';
import { Form, Formik } from 'formik';
import { closeModal } from 'reducers/modal';
import { Button } from 'components/button/Button';
import { FormRadioButtonsField } from '../../pages/matchingProcess/matchingProcessPages/CustomFormFields/FormRadioButtonsField';
import { selectAssessmentName } from 'reducers/assessment';
import { options } from './constants'


export const AssessmentsPracticeAccesibilityModal = () => {
  const dispatch = useDispatch();
  const assessmentName = useSelector(selectAssessmentName);
  const accessibilityData = useSelector(selectAccessibilityData);
  const webSkinDetails = useSelector(selectWebskin);

  useEffect(() => {
    const accessibilityContainer = document.getElementsByClassName(
      'CheckboxFieldContainer'
    )[0] as HTMLElement;
    const radioFirstOpt = accessibilityContainer.querySelector(
      "input[name='accessibilityChoice']:checked"
    ) as HTMLElement;
    radioFirstOpt?.focus();
  }, []);

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const handleSubmit = (values: any) => {
    const { textColour, tileColour, classStr, isLight } =
      options[parseInt(values.accessibilityChoice)];

    if (
      values.accessibilityChoice === '0' &&
      webSkinDetails &&
      webSkinDetails !== 'defaultTheme'
    ) {
      let webSkinTxtColour = '';
      let txtColourArr = webSkinDetails.textColours;

      for (let i = 0; i < txtColourArr.length; i++) {
        if (txtColourArr[i].code === 'TC_General') {
          webSkinTxtColour = txtColourArr[i].colourValue;
        }
      }

      dispatch(
        setAccessibilityData({
          textColor: webSkinTxtColour ? webSkinTxtColour : textColour,
          backgroundColor: tileColour,
          titleColor: webSkinTxtColour ? webSkinTxtColour : textColour,
          borderColor: textColour,
          classStr: classStr,
          errorTextColor:
            values.accessibilityChoice === '0'
              ? '#d83838'
              : webSkinTxtColour
              ? webSkinTxtColour
              : textColour,
          optionNumber: parseInt(values.accessibilityChoice),
          isSet: values.accessibilityChoice === '0' ? false : true,
          siteAccessibilityColour: 'SiteAccessibility' + classStr,
          isLight,
        })
      );
    } else {
      dispatch(
        setAccessibilityData({
          textColor: textColour,
          backgroundColor: tileColour,
          titleColor: textColour,
          borderColor: textColour,
          classStr: classStr,
          errorTextColor:
            values.accessibilityChoice === '0' ? '#d83838' : textColour,
          optionNumber: parseInt(values.accessibilityChoice),
          isSet: values.accessibilityChoice === '0' ? false : true,
          siteAccessibilityColour: 'SiteAccessibility' + classStr,
          isLight,
        })
      );
    }
    handleCloseModal();
  };

  const modalStyle = {
    '--modalTitleColor': '#036C8F',
    '--footerBackgroundColor': '#f5f5f5',
    '--footerBorderColor': '#f5f5f5',
    '--primaryButtonBackgroundColor': '#36705B',
    '--tertiaryButtonBackgroundColor': '#d5d5d5',
  } as React.CSSProperties;

  const currentWebskin = window.sessionStorage.getItem('webskin')
    ? window.sessionStorage.getItem('webskin')
    : 'defaultTheme';

  return (
    <div
      className={
        'AssessmentModal Accessibility' +
        (assessmentName ? ' ' + assessmentName : '') +
        (currentWebskin !== 'defaultTheme' ? ' ' + currentWebskin : '') +
        ' ' +
        accessibilityData.classStr
      }
      style={modalStyle}
    >
      <Formik
        initialValues={{
        accessibilityChoice: options.find(accessabilityOption => {
          return accessibilityData.siteAccessibilityColour?.includes(accessabilityOption.classStr)
        })?.optionId.toString() || accessibilityData.optionNumber.toString() || ''
        }}
        onSubmit={handleSubmit}
      >
        {({ isValid, isSubmitting }) => (
          <Form>
            <div className="TileRowInner">
              <FormRadioButtonsField
                fieldName={'accessibilityChoice'}
                label={''}
                options={options}
                key={`AccessibilityOptionsKey`}
                accessibleLabels={[
                  'Accessible settings option 1, change site to use it\'s default colours.',
                  'Accessible settings option 2, change site to use yellow text on black background.',
                  'Accessible settings option 3, change site to use white text on black background.',
                  'Accessible settings option 4, change site to use black text on yellow background.',
                ]}
              />
            </div>
            <div className="ModalFooter">
              <Button
                className="Rounded"
                priority="tertiary"
                type="button"
                onClick={handleCloseModal}
              >
                Cancel
              </Button>
              <Button
                className="Discard Rounded"
                priority="primary"
                type="submit"
              >
                Apply
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};
